import script from "./ProfileViewer.vue?vue&type=script&setup=true&lang=ts"
export * from "./ProfileViewer.vue?vue&type=script&setup=true&lang=ts"

import "./ProfileViewer.vue?vue&type=style&index=0&id=05c8881f&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-05c8881f"]])

export default __exports__